<template>
  <div class="collection-calendar-container">
    <!-- ページヘッダー -->
    <div class="page-header mb-4">
      <div class="header-content">
        <h4 class="mb-0">
          <i class="bi bi-calendar-check me-2 text-primary"></i>収集カレンダー設定
        </h4>
        <BaseButton
          variant="secondary"
          size="sm"
          @click="handleBackToMenu"
        >
          <i class="bi bi-arrow-left me-2"></i>メニューに戻る
        </BaseButton>
      </div>
    </div>

    <!-- 地区一覧テーブル -->
    <InfoTableSection
      title=""
      :headers="['地区名', '操作']"
      :items="districts"
      :loading="loading"
      :error="error"
      empty-message="登録されている収集地区がありません"
      :pagination="{ enabled: true, perPage: 10 }"
      @action="handleTableAction"
    >
      <template #tableRow="{ item }">
        <BTd class="district-name">
          <ContentText color="default">{{ item.districtName }}</ContentText>
        </BTd>
        <BTd class="text-center">
          <BaseButton
            size="sm"
            variant="primary"
            @click="handleOpenCalendar(item)"
          >
            <i class="bi bi-calendar-check me-1"></i>設定
          </BaseButton>
        </BTd>
      </template>
    </InfoTableSection>
  </div>
</template>

<script setup>
import { BTd } from 'bootstrap-vue-next'
import BaseButton from '@/components/atoms/BaseButton.vue'
import ContentText from '@/components/atoms/ContentText.vue'
import InfoTableSection from '@/components/organisms/InfoTableSection.vue'

const props = defineProps({
  districts: {
    type: Array,
    default: () => []
  },
  loading: {
    type: Boolean,
    default: false
  },
  error: {
    type: String,
    default: null
  }
})

const emit = defineEmits(['open-calendar', 'back-to-menu'])

const handleOpenCalendar = (district) => {
  emit('open-calendar', district)
}

const handleBackToMenu = () => {
  emit('back-to-menu')
}

const handleTableAction = (action) => {

}
</script>

<style lang="scss" scoped>
.collection-calendar-container {
  padding: 1.5rem 0;
}

.page-header {
  .header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: 2rem;
    margin-right: 2rem;
    padding-bottom: 1rem;
    border-bottom: 2px solid #e9ecef;
  }

  h4 {
    color: #1f2937;
    font-weight: 600;
    flex: 1;
    display: flex;
    align-items: center;
    margin-bottom: 0;
  }
}

.district-name {
  font-weight: 600;
  color: #374151;
}

// 戻るボタンのスタイリング
.page-header button {
  border-radius: 0.5rem;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }
}

@media (max-width: 768px) {
  .page-header {
    .header-content {
      flex-direction: column;
      align-items: flex-start;
      gap: 1rem;
      margin-left: 1rem;
      margin-right: 1rem;
    }

    h4 {
      order: 1;
    }

    button {
      order: 2;
      align-self: flex-end;
    }
  }
}
</style>
